import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { PlanProfile as PlanProfileDomain } from '../../../logic/domains/planProfile.domain';
import { getPlanProfile } from '../../../logic/functions/planProfile.function';
import PlanProfile from '../../presentational/Profile/PlanProfile/PlanProfile';
import Search from '../../presentational/Search/Search';
import { showInfo } from '../../../events/NotificationEmitter';
import { isMobile } from '../../../screens';
import { getRecentClientsResultsAction } from '../../../store/actions/recent-clients.actions';
import { useAdviserDetails } from '../../hooks/AppStateHook';

const PlanProfileContainer: FunctionComponent<{}> = () => {
	const [planProfile, setPlanProfile] = useState<PlanProfileDomain>();
	const [isLoading, setIsLoading] = useState(true);
	const { planUUID } = useParams();
	const dispatch = useDispatch();
	const { customerToken } = useAdviserDetails();

	if (!planUUID) {
		throw new Error('Missing mandatory path parameter: planUUID');
	}

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			setPlanProfile(await getPlanProfile(planUUID));
			setIsLoading(false);
			if (isMobile) {
				showInfo(
					'Mobile view - For full page content, please view on a desktop device.'
				);
			}
		};
		fetchData();
	}, [planUUID]);

	useEffect(() => {
		if (customerToken) {
			dispatch(getRecentClientsResultsAction(customerToken));
		}
	}, [planUUID, customerToken]);

	return (
		<Fragment>
			<Search isAdvanced={true} />
			<PlanProfile
				loading={isLoading}
				planUUID={planUUID}
				planProfile={planProfile!}
			/>
		</Fragment>
	);
};

export default PlanProfileContainer;
